import Api from '@/shared/services/Api'


export default 
{

	login(data) {
		return Api().post('login', data)
	},

	register(data) {
		return Api().post('register', data)
	},

	resendEmail(data) {
		return Api().post('resend-email', data)
	},

	activateAccount(data) {
		return Api().post('activate-account', data)
	},

	forgotPassword(data) {
		return Api().post('forgot-password', data)
	},

	changePasswordAuth(data) {
		return Api().post('change-password-auth', data)
	},

	getUser() {
		let data = {
			token: localStorage.getItem('token')
		}

		return Api().post('get-user', data)
	},

	changePassword(data) 
	{
		data.token = localStorage.getItem('token')
		return Api().post('change-password', data)
	},

	changeEmail(data) {
		return Api().post('change-email', data)
	},

	updatePerfil(data) 
	{
		data.token = localStorage.getItem('token')
		return Api().post('update-perfil', data)
	},

	abandonarCuenta() {
		let data = {
			token: localStorage.getItem('token')
		}

		return Api().post('abandonar-cuenta', data)
	},

}